// Linear Copilot's identity, once: the bridge announces its version in the page's hello and names
// its declared grant for the host-run sign-in (bridge.ts), and build.mjs writes it into the generated
// manifest. Bump `version` whenever the generated manifest changes — tools, grants, redirects, CSP —
// so the version a human reads names what an install runs (`make check-agentic-app-manifest-version`
// fails an unbumped change; 0.15.1: FR-10's Android redirect sat unoffered at 0.15.0; 0.15.2:
// share_issue_link re-annotated non-destructive, action-limit Q5; 0.15.3: every other write declares
// destructiveHint false, since an absent hint reads as destructive — absent-destructive-hint-reads-as-destructive).
export const APP = {
  id: "com.resatech.talkie.linear-copilot",
  name: "Linear Copilot",
  version: "0.15.3",
  description:
    "Triage, plan, and act on Linear issues without leaving Talkie. Dobby can show your issues and draft new ones; nothing is created or changed in Linear until you confirm.",
  origin: "https://linear-copilot.touchtalkie.com",
} as const;

/** The one grant name this app declares. */
export const LINEAR_GRANT = "linear";

/**
 * What the app asks Talkie for. ⭐ Every grant value is one the HOST acts on — it builds the
 * authorize URL, picks the redirect, joins the scopes and POSTs to the API endpoint — so
 * `fixture_manifests_parse` pins each field of the generated manifest.
 */
export const REQUESTED_CAPABILITIES = {
  // ⛔ EMPTY: the page connects to nothing but its own origin — the HOST makes every Linear call
  // through the grant below — and the vhost serves `connect-src 'self'` to match (the server's
  // served-CSP check refuses an install whose page may connect wider than this list).
  connect_domains: [] as string[],
  oauth_grants: [
    {
      name: LINEAR_GRANT,
      authorize_url: "https://linear.app/oauth/authorize",
      token_url: "https://api.linear.app/oauth/token",
      revocation_url: "https://api.linear.app/oauth/revoke",
      // The PROD public PKCE client id (owner approved committing it, 2026-09-02). Dev runs Linear's
      // separate "Talkie Dev" app: the generated `.dev.json` swaps in its id from
      // `fixtures/shared/dev-oauth-clients.json` (owner 2026-10-20).
      client_id: "3928ffaf69834dcb5a47dae3ecae289d",
      scopes: ["read", "write", "issues:create", "comments:create"],
      // ⛔ COMMA, not the RFC 6749 space: Linear's docs say "Comma separated list of scopes".
      scope_separator: ",",
      extra_authorize_params: { actor: "user" },
      api_request_url: "https://api.linear.app/graphql",
      // The HOSTS' callbacks (the app holds no token): web-proxy's prod callback, the desktop
      // listener, and the Android App Link (connector-oauth-android-app-link FR-10). Each must also be
      // registered at Linear. The DEV web callback is added to the generated `.dev.json` only
      // (`gen-dev-agentic-manifest.py`). The Android URI is LAST on purpose: until the host selects an
      // Android redirect by exact URI (`app-routed-redirect-selection-is-order-dependent`) it takes the
      // first app-routed declaration, and moving this one earlier would send the S21 to a path its
      // manifest filter does not yet claim.
      redirect_uris: [
        "https://app.touchtalkie.com/oauth/app-grant/callback",
        "http://127.0.0.1:8791/callback.html",
        "https://app.touchtalkie.com/oauth/app-grant/android/callback",
      ],
    },
  ],
  connectors: ["gmail", "google-calendar"],
};
